import { create } from 'zustand';

export type EvidenceTimelineRowData = Record<string, unknown>;

interface EvidenceTimelineState {
  evidenceTimelineRow: EvidenceTimelineRowData | null;
  setEvidenceTimelineRow: (row: EvidenceTimelineRowData | null) => void;
}

export const useEvidenceTimelineStore = create<EvidenceTimelineState>(set => ({
  evidenceTimelineRow: null,
  setEvidenceTimelineRow: row => set({ evidenceTimelineRow: row }),
}));
